import { PlannedTwinID } from '@ynomia/core/dist/blueprint';
import { SET_PLANNED_TWIN_IDS, SET_FETCHING_PLANNED_TWIN_IDS } from '../actions/actionTypes';
import { PlanAction, PlanStateType } from '../context';

export default (
  state: PlanStateType,
  action: PlanAction,
): PlanStateType => {
  switch (action.type) {
    case SET_PLANNED_TWIN_IDS: {
      const incoming = action.payload as Map<string, PlannedTwinID>;
      const current = state.plannedTwinIDsKeyedById;
      const isSame = current.size === incoming.size
        && [...incoming].every(([k, v]) => {
          const existing = current.get(k);
          return existing && existing.updated === v.updated;
        });
      if (isSame) return state;

      const plannedTwinIDsKeyedById = new Map<string, PlannedTwinID>([...incoming]);
      return { ...state, plannedTwinIDsKeyedById };
    }
    case SET_FETCHING_PLANNED_TWIN_IDS:
      return {
        ...state,
        isFetchingPlans: action.payload,
      };
    default:
      return state;
  }
};
